<div class="imagemap">
	<h5>Image map</h5>
	<textarea name="comment" rows="0" [(ngModel)]="imageRef.imageMap" (stagesDebouncedChange)="onChange()"></textarea>
</div>
